import { Component, input } from '@angular/core';

@Component({
  selector: 'what-users-see-card',
  standalone: true,
  imports: [],
  templateUrl: './what-users-see-card.component.html',
  styleUrls: ['./what-users-see-card.component.scss'],
})
export class WhatUsersSeeCardComponent {
  title = input('');
  description = input<string>();
}
